import classNames from 'classnames';
import styles from './ServiceNavigation.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';

export interface UI_ServiceNavigationProps {
	className?: string;
	serviceNavigationItems?: Array<UI_ServiceNavigationItemProps>;
	lastItemRef?: React.Ref<HTMLAnchorElement>;
}

export interface UI_ServiceNavigationItemProps {
	id: number;
	name: string;
	url: string;
	descendants?: Array<UI_ServiceNavigationItemProps>;
	current?: boolean;
	active?: boolean;
	hidden?: boolean;
	title?: string;
}

export const UI_ServiceNavigation = ({ className, serviceNavigationItems, lastItemRef }: UI_ServiceNavigationProps) => {
	if (!serviceNavigationItems) return null;
	return (
		<ul className={classNames(styles.ServiceNavigation, className)}>
			{serviceNavigationItems.map((item: UI_ServiceNavigationItemProps, index) => (
				<li key={index} className={styles.ServiceNavigation_item}>
					<UI_Link
						className={styles.ServiceNavigation_link}
						href={item.url}
						{...item}
						style="md"
						ref={index === serviceNavigationItems.length - 1 ? lastItemRef : undefined}
					>
						{item.title || item.name}
					</UI_Link>
				</li>
			))}
		</ul>
	);
};
